import { sanitizeInput } from "../common/security-utils";
import workflowTick from "../../assets/svg/workflow-tick.svg";

const AllocationHistoryTab = ({ isHistoryLoading, allocationHistory }) => {
    /** Get status color based on allocation status */
    const getStatusColor = (status) => {
        switch (status) {
            case "Pending":
                return "#ff3469E7";
            case "Accepted":
                return "#ff40AE4A";
            case "Rejected":
                return "#ffD72727";
            default:
                return "#ffD72727";
        }
    };

    /** Get status display label */
    const getStatusLabel = (status) => {
        return status === "Pending" ? "Allocated" : status ?? "-";
    };

    /** Get status description text */
    const getStatusDescription = (row) => {
        if (row.status === "Pending") return `Allocated to ${row.driver ?? "-"}`;
        if (row.status === "Accepted") return ` ${row.driver ?? "-"} accepted allocation request !`;
        if (row.status === "Rejected") return `${row.comment}`;
        return ` ${row.driver ?? "-"}`;
    };

    return (
        <div className="w-100 m-2 bg-white rounded-4 p-3">
            <div className="row">
                <div className="col-12 ">
                    <div className="row">
                        <div className="col-xl-12 d-flex justify-content-start">
                            <p className="fs-18 fw-600 mb-0">Allocation History </p>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-12">
                            <div>
                                {isHistoryLoading
                                    ? Array.from({ length: 3 }).map((_, idx) => (
                                        <div key={idx} className="w-100 d-flex justify-content-start mb-3">
                                            <div className="d-flex flex-column align-items-center">
                                                <div className="skeleton" style={{ width: "24px", height: "24px", borderRadius: "50%" }} />
                                                {idx !== 2 && <div style={{ borderLeft: "2px dotted #ddd", height: "60px" }}></div>}
                                            </div>
                                            <div className="ms-3 flex-grow-1">
                                                <div className="skeleton skeleton-text" style={{ width: "100px", height: "16px", marginBottom: "8px" }} />
                                                <div className="skeleton skeleton-text-sm" style={{ width: "200px", marginBottom: "4px" }} />
                                                <div className="skeleton skeleton-text-sm" style={{ width: "150px" }} />
                                            </div>
                                        </div>
                                    ))
                                    : allocationHistory.map((row, index) => (
                                        <div key={row.id || index} className="w-100 d-flex justify-content-start ">
                                            <div className="d-flex flex-column align-items-center" style={{ height: "auto" }}>
                                                <img src={workflowTick} alt="tick" />
                                                {index + 1 !== allocationHistory.length && (
                                                    <div style={{ borderLeft: "2px dotted #aaa", height: "100%" }}></div>
                                                )}
                                            </div>

                                            <div className="mt-0 ms-3 mb-3">
                                                <div className="d-flex align-items-center justify-content-start">
                                                    <span
                                                        className="fs-14 fw-700 "
                                                        style={{
                                                            color: getStatusColor(row.status),
                                                        }}
                                                    >
                                                        {sanitizeInput(getStatusLabel(row.status))}
                                                    </span>
                                                </div>

                                                <div className="mt-1 fs-13 fw-400 textFontColor d-flex justify-content-start">{sanitizeInput(getStatusDescription(row))}</div>
                                                <div className="mt-1 fs-12 fw-400 cardTextGrey d-flex justify-content-start">{sanitizeInput(row.date ?? "")}</div>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllocationHistoryTab;
